function filterStorageLeases(list, query) {
  const rows = Array.isArray(list) ? list : [];
  const q = (query || '').toLowerCase().trim();
  if (!q) return rows;
  const tokens = q.split(/\s+/).filter(Boolean);
  return rows.filter((row) => {
    const haystack = [
      row.tenant,
      row.address,
      row.locker,
      row.fee,
      row.term,
      row.status,
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
    return tokens.every((tok) => haystack.includes(tok));
  });
}

export { filterStorageLeases };
